export const EmptyComponent = () => {
  return null;
};
